import React from "react";
import graph from "./graph";

import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { isEmptyObject } from "helpers/formatObject";
import { DeleteOutlineRounded } from "@mui/icons-material";
import {
  NewDialog,
  NewDialogTitle,
  NewDialogContent,
  NewDialogActions,
} from "components";
import {
  Stack,
  Avatar,
  Button,
  Typography,
  IconButton,
  CircularProgress,
} from "@mui/material";

export default function Delete({ id, refetch, title = "حذف" }) {
  const [open, setOpen] = React.useState(false);
  const { userToken } = useSelector((state) => state.auth);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const [handleDelete, { loading }] = useMutation(graph.delete.query, {
    context: {
      serviceName: graph.delete.serviceName,
      headers: {
        authorization: `Bearer ${userToken}`,
      },
    },
  });

  const onDelete = async () => {
    try {
      const { data, errors } = await handleDelete({
        variables: { ids: id },
      });
      if (!errors) {
        refetch();
        onClose();
        if (!isEmptyObject(data)) {
          data[graph.delete.name]?.messages.map((message) =>
            toast.success(String(message))
          );
        }
      }
    } catch (error) {}
  };

  return (
    <>
      <IconButton
        size="small"
        color="error"
        onClick={onOpen}
        sx={{ bgcolor: "action.hover" }}
      >
        {loading ? (
          <CircularProgress color="error" size={20} />
        ) : (
          <DeleteOutlineRounded color="error" fontSize="small" />
        )}
      </IconButton>
      <NewDialog open={open} onClose={onClose}>
        <NewDialogTitle title={title} onClose={onClose} />
        <NewDialogContent isPopup>
          <Stack
            flex={1}
            rowGap={2}
            alignItems="center"
            justifyContent="center"
            bgcolor="background.paper"
          >
            <Avatar
              variant="rounded"
              sx={{
                width: 120,
                height: 120,
                borderRadius: 4,
                bgcolor: "action.hover",
              }}
              src="/assets/icons/glass/trash.svg"
            />
            <Typography variant="subtitle1">
              آیا از حذف این مورد مطمئن هستید؟
            </Typography>
          </Stack>
        </NewDialogContent>
        <NewDialogActions>
          <Button color="warning" variant="outlined" onClick={onClose}>
            فعلا نه
          </Button>
          <Button
            autoFocus
            color="error"
            variant="contained"
            disabled={loading}
            onClick={onDelete}
            sx={{ minWidth: 80 }}
          >
            {loading ? <CircularProgress color="inherit" size={24} /> : "بله"}
          </Button>
        </NewDialogActions>
      </NewDialog>
    </>
  );
}
